<template>
  <div>
    <el-dialog
      width="1100px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <template slot="title">
        <span class="f-s-16">
          <span>选择调出仓库存物料（{{ cond.warehouse_name }}）</span>
          <span class="c-red">(已选{{ selfList.length }})</span>
        </span>
      </template>
      <div class="page-main">
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          :height="this.$util.getViewHeight() - 310"
          @keydown="tableKeydown"
          @checkbox-change="tableCheckboxChange"
          @checkbox-all="tableCheckboxChange"
        >
          <template #header_input="{ column }">
            <el-input
              v-model="filterData[column.field]"
              size="mini"
              clearable
              :placeholder="column.title"
              @change="searchListData"
            />
          </template>
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    // { warehouseId, warehouse_name }
    cond: {
      type: Object,
      default: () => ({})
    },
    // 已加入调拨明细的行，用于回显勾选
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: [],
      filterData: {
        material_name: '',
        category: '',
        spec: '',
        batch_no: ''
      },
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        checkboxConfig: {
          trigger: 'row',
          reserve: true
        },
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          { fixed: 'left', type: 'checkbox', width: 40 },
          { fixed: 'left', title: '序号', type: 'seq', width: 40 },
          { field: 'location_name', title: '仓位', width: 90 },
          { field: 'material_name', title: '物料名称', width: 150, slots: { header: 'header_input' } },
          { field: 'category', title: '材质', width: 90, slots: { header: 'header_input' } },
          { field: 'spec', title: '规格(mm)', width: 130, slots: { header: 'header_input' } },
          { field: 'unit', title: '单位', width: 60 },
          { field: 'batch_no', title: '批号', width: 120, slots: { header: 'header_input' } },
          { field: 'qty', title: '库存数量', width: 90 }
        ],
        data: []
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    // 已有明细按库存行id(source_item_id)回显勾选
    this.selfList = this.list
      .filter((item) => item.source_item_id)
      .map((item) => ({ source_item_id: item.source_item_id }))
    this.searchListData()
  },
  methods: {
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.tableOptions.loading = true
      let params = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        warehouseId: this.cond.warehouseId,
        filterData: this.filterData
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/inventory/stocklist',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = this.$util.deepCopy(res.data.page.list) || []
            this.tableOptions.data.forEach((item) => {
              // 库存行id作为去重键
              item.source_item_id = item.id
            })
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
            // 回显跨页选中
            this.tableOptions.data.forEach((itemSt) => {
              this.selfList.forEach((itemNd) => {
                if (itemNd.source_item_id === itemSt.source_item_id) {
                  this.$nextTick(() => {
                    this.$refs.refTable.setCheckboxRow([itemSt], true)
                  })
                }
              })
            })
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    tableCheckboxChange(params) {
      let resultDiff = this.selfList.filter((itemSt) => {
        return this.tableOptions.data.every((itemNd) => itemSt.source_item_id !== itemNd.source_item_id)
      })
      let resultCheck = [...params.records]
      this.selfList = [...resultDiff, ...resultCheck]
    },
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        params.$event.preventDefault()
        let row = this.$refs.refTable.getCurrentRecord()
        let isChecked = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isChecked)
      }
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupConfirm() {
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
